import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IWorkspace as ISitemateStartWorkspace } from '@site-mate/sitemate-global-shared/lib';

import { HttpClientService } from 'app/shared/service/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(private http: HttpClientService) {}

  getFlowsiteWorkspaces(accountId: string): Observable<ISitemateStartWorkspace[]> {
    return this.http.get(`account/${accountId}/flowsite-workspaces`);
  }
}
